import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Selectable row of an entity search result: check box + agency icon + name/address */
var EntitySearchResultItem = function EntitySearchResultItem(props) {
  var entity = props.entity,
      selected = props.selected,
      onSelect = props.onSelect;
  /**
   * methods
   */

  var selectAction = function selectAction() {
    onSelect(entity);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex cursor-pointer flex-row items-center space-x-4 rounded-2xl border bg-white px-5 py-4 transition-colors', selected ? 'border-[#3B5BFF] bg-[#3B5BFF]/5' : 'border-black/10 hover:border-[#12275B]/25'),
    onClick: selectAction,
    children: [/*#__PURE__*/_jsx(Box, {
      className: clsx('flex h-5 w-5 flex-shrink-0 items-center justify-center rounded border transition-colors', selected ? 'border-[#3B5BFF] bg-[#3B5BFF]' : 'border-gray-300 bg-white'),
      children: selected && /*#__PURE__*/_jsx(Box, {
        component: "svg",
        viewBox: "0 0 24 24",
        className: "h-3 w-3 fill-white",
        children: /*#__PURE__*/_jsx("path", {
          d: "M9.6 15.6 4.8 10.8l1.4-1.4 3.4 3.4 8-8 1.4 1.4z"
        })
      })
    }), /*#__PURE__*/_jsx(Box, {
      className: "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-[#3B5BFF]/10",
      children: /*#__PURE__*/_jsx(Box, {
        component: "svg",
        viewBox: "0 0 24 24",
        className: "h-5 w-5 fill-[#3B5BFF]",
        children: /*#__PURE__*/_jsx("path", {
          d: "M4 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4h2a2 2 0 0 1 2 2v10h-6v-4h-4v4H4zm4-14v2h2V7H8zm0 4v2h2v-2H8zm4-4v2h2V7h-2zm0 4v2h2v-2h-2z"
        })
      })
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex min-w-0 flex-col",
      children: [/*#__PURE__*/_jsx(Typography, {
        className: "truncate text-sm font-bold text-[#12275B]",
        children: entity === null || entity === void 0 ? void 0 : entity.name
      }), /*#__PURE__*/_jsx(Typography, {
        className: "truncate text-xs text-gray-500",
        children: entity === null || entity === void 0 ? void 0 : entity.location
      })]
    })]
  });
};

export default EntitySearchResultItem;